import React from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { ErrorOutlineOutlined } from '@mui/icons-material'
import { muiOptions } from '../../infrastructure/materialUiThemeProvider'
import { isMovementListItem, MovementListItem } from './stockModels'
import { MovementStatusChip } from './statusChip'
import { DealMovementItem } from '../deals/dealModels'

export function MovementStatusIcon({ movementItem, classes }: { movementItem: MovementListItem | DealMovementItem, classes: any }) {
    if (movementItem.movementStatus == null) return (<></>)

    let isOnError = isMovementListItem(movementItem) ? movementItem.isExpiredForecastOrPlanned : false

    return (
        <div className={classes.flexRow}>
            <ErrorOutlineOutlined className={isOnError ? classes.red : classes.invisible} />
            <MovementStatusChip status={movementItem.movementStatus} fontSize='small' />
        </div>)
}

let styles = theme =>
    createStyles({
        flexRow: {
            display: 'flex',
            alignItems: 'center'
        }
    })

export default withStyles(styles, muiOptions)(MovementStatusIcon)